import styled, { css } from 'styled-components';

export const Root = styled.div`
  position: relative;
  overflow: auto;
  flex: 1;
  display: flex;
  justify-content: space-around;
  height: auto;
`;

export const TableWrapper = styled.div`
  overflow: scroll;
  display: flex;
  flex-flow: row wrap;
  flex-direction: column;
  height: auto;
  & > div {
    display: flex;
    flex-wrap: wrap;
    ${(props) => props.width
      && css`
        width: ${props.width};
      `}
  }
`;

export const TableItem = styled.div`
  padding: 8px;
  text-align: left;
  width: 80px;
  flex-shrink: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${(props) => props.width
    && css`
      width: ${props.width}px;
    `}
  ${(props) => props.highlight
    && css`
      background-color: ${({ theme }) => theme.palette.warning.light};
      color: ${({ theme }) => theme.palette.common.white};
    `}
  &:last-child {
    margin-right: 0;
  }
`;

export const TableRow = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.common.white};
  &:last-child {
    border: none;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const TableHeader = styled.div`
  position: sticky;
  top: 0;
  color: ${({ theme }) => theme.palette.primary.dark};
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  & ${TableRow} {
    position: sticky;
    top: 0;
    padding: 0 15px 15px 20px;
    align-items: baseline;
    display: flex;
  }
`;

export const RowInfo = styled.div`
  align-items: stretch;
  display: flex;
  padding: 0 15px 0 20px;
  width: 100%;
`;

export const TableBody = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.palette.gray.dark};
  max-height: 500px;
  & ${TableRow} {
    &:nth-child(odd) {
      & ${RowInfo} {
        background-color: ${({ theme }) => theme.palette.gray.lightest};
      }
    }
  }
`;
